@use '../../../scss/utility';

@use 'modal-vars';

:host {
  @include modal-vars.wb-modal-vars;

  @include utility.breakpoint-from(mq4) {
    @include modal-vars.wb-modal-desktop-vars;
  }

  display: flex;
  inset-block-start: 0;
  inset-inline-start: 0;
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  pointer-events: auto;
  position: fixed;
  z-index: var(--z-index);
  background-color: var(--modal-overlay-background-color);
  justify-content: center;
  align-items: center;
  overflow: auto;
  transition: opacity var(--modal-animation-duration) var(--wb-fade);
  opacity: 0;
}

:host(.is-animating) {
  pointer-events: none;
}

:host([variant='edit'][visible]),
:host([variant='edit-mobile-fullscreen'][visible]),
:host([variant='info'][visible]),
:host([variant='prompt'][visible]) {
  opacity: initial;

  .outer {
    transform: initial;
    @media (prefers-reduced-motion) {
      transform: translateY(0);
    }
  }
}

:host([variant='edit']),
:host([variant='edit-mobile-fullscreen']) {
  .outer {
    width: 100%;
    transition: transform var(--modal-animation-duration) var(--wb-fade);
    transform: translateY(100px);
    align-self: flex-end;

    @include utility.breakpoint-from(mq4) {
      align-self: center;
    }

    @media (prefers-reduced-motion) {
      transform: translateY(0);
      transition: transform 0s;
    }
  }
}

:host([variant='edit-mobile-fullscreen']) {
  @include utility.breakpoint-to(mq3) {
    .outer {
      min-height: 100%;
    }

    .inner {
      height: auto;
    }
  }
}

:host([variant='info']) {
  @include utility.breakpoint-from(mq4) {
    padding-block-start: var(--wb-spacing-xs);
    padding-block-end: var(--wb-spacing-xs);
  }

  .outer {
    width: 100%;
    height: 100%;
    transition: transform var(--modal-animation-duration) var(--wb-fade);
    transform: scale3d(0.8, 0.8, 0.8);

    @media (prefers-reduced-motion) {
      transform: scale3d(1, 1, 1);
      transition: transform 0s;
    }

    @include utility.breakpoint-from(mq4) {
      align-self: center;
      height: initial;
      max-height: 100%;
    }
  }

  .inner {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: auto;
  }
}

:host([variant='prompt']) {
  @include utility.breakpoint-from(mq4) {
    padding-block-start: var(--wb-spacing-m);
  }

  .outer {
    width: 100%;
    transition: transform var(--modal-animation-duration) var(--wb-fade);
    transform: translateY(100px);
    align-self: flex-end;

    @media (prefers-reduced-motion) {
      transform: translateY(0);
      transition: transform 0s;
    }

    @include utility.breakpoint-from(mq4) {
      align-self: flex-start;

      @media (prefers-reduced-motion) {
        transform: translateY(0);
      }
    }
  }
}

.outer {
  box-sizing: border-box;
  display: flex;
  max-height: 100%;
  position: relative;
  width: 100%;
  overflow: hidden; // prevent scrollbars during animation
}

.inner {
  display: block;
  box-sizing: border-box;
  overflow: auto;
  outline: 0;
  width: 100%;
  height: 100%;
  min-height: inherit;
  max-height: inherit;
  background-color: var(--modal-background-color);
  border-radius: var(--modal-border-radius);
}

.wb-grid {
  height: 100%;
  inset-block-start: 0;

  // modal is specified to take in full width on mobile devices
  @include utility.breakpoint-to(mq3) {
    max-width: 100%;
    width: 100%;
  }
}

.wb-grid-row {
  height: 100%;
}
